import styled from 'styled-components';
import { defaultTransition } from 'styles/utils';
import { FrameHeaderHeight } from 'styles/constants';

const ellipsis = `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DropdownInitialWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  min-width: 8rem;
  height: ${FrameHeaderHeight}px;
  padding: 0 1rem 0 0;
  color: ${props => props.theme.color.wfWhite};
  cursor: pointer;
  user-select: none;
  ${defaultTransition('opacity')}
  &:hover {
    opacity: 0.8;
  }
`;

export const DropdownTitleWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  min-width: 8rem;
  height: ${FrameHeaderHeight}px;
  padding: auto 0.5rem;
  color: ${props => props.theme.color.wfWhite};
  background-color: ${props => props.theme.color.wfBlack};
  ${ellipsis}
`;

export const DropdownContentWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  max-width: 22rem;
`;

export const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: ${FrameHeaderHeight}px;
  ${defaultTransition('opacity')}
  background-color: ${props =>
    props.selected ? props.theme.color.wfGrey800 : props.theme.color.wfGrey900};
  &:hover {
    background-color: ${props => props.theme.color.wfGrey700};
  }
`;

export const RowTitleWrapper = styled.div`
  font-size: ${props => props.theme.font.size.small};
  margin: auto 1rem;
  min-width: 4.5rem;
  color: ${props => props.theme.color.wfWhite};
  ${ellipsis}
`;

export const RowDescriptionWrapper = styled.div`
  font-size: ${props => props.theme.font.size.small};
  font-style: italic;
  margin: auto 0.8rem auto 0;
  color: ${props => props.theme.color.wfGrey500};
  ${ellipsis}
`;
